module.exports = __webpack_public_path__ + "img/tyy_tbt1259-1991.prt.649bf561.jpg";